<template>
  <dx-modal
    title="Assinar impresso"
    size="sm"
    :value="show"
    @input="close"
    id="modal-sign-document"
  >
    <div class="sign-document-intro">
      <div class="sign-document-icon">
        <fa-icon :icon="['fal', 'signature']" />
      </div>
      <div>
        <div class="text-bold">Assinatura digital com Bird ID</div>
        <div class="sign-document-description">
          O impresso ganha validade jurídica ICP-Brasil e não pode mais ser alterado.
        </div>
      </div>
    </div>
    <div class="form-group" :class="{ 'has-error': $v.form.kind.$error }">
      <label class="form-label" for="sign-document-kind">Tipo do documento</label>
      <select
        id="sign-document-kind"
        class="form-select"
        v-model="form.kind"
        @change="$v.form.kind.$touch()"
      >
        <option value="">Selecione</option>
        <option
          v-for="(name, value) in documentKinds"
          :value="value"
          :key="value"
        >{{ name }}</option>
      </select>
      <template v-if="$v.form.kind.$error">
        <div class="form-input-hint" v-if="!$v.form.kind.required">
          Campo obrigatório
        </div>
      </template>
    </div>
    <div class="form-group">
      <label class="form-label" for="sign-document-page-size">Formato</label>
      <select
        id="sign-document-page-size"
        class="form-select"
        v-model="form.pageSize"
      >
        <option v-for="size in pageSizes" :value="size" :key="size">{{ size }}</option>
      </select>
    </div>
    <template slot="footer">
      <button
        type="button"
        class="btn btn-primary btn-icon btn-icon-left mr-1"
        @click="sign"
      ><fa-icon :icon="['fal', 'signature']" /> Assinar impresso</button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { documentKinds, pageSizes } from '@/data/digital-signature';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    kind: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      documentKinds,
      pageSizes,
      form: {
        kind: this.kind || '',
        pageSize: pageSizes[0],
      },
    };
  },
  validations: {
    form: {
      kind: { required },
    },
  },
  methods: {
    sign() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      this.$emit('sign', { ...this.form });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

#modal-sign-document {
  .sign-document-intro {
    align-items: center;
    background-color: $gray-color-ultra-light;
    border-radius: $border-radius;
    display: flex;
    gap: $layout-spacing;
    margin-bottom: $layout-spacing-lg;
    padding: $layout-spacing;
  }
  .sign-document-icon {
    align-items: center;
    background-color: $light-color;
    border-radius: 50%;
    box-shadow: 0 .05rem .2rem rgba($dark-color, .12);
    color: $primary-color;
    display: flex;
    flex: 0 0 1.8rem;
    font-size: $font-size-lg;
    height: 1.8rem;
    justify-content: center;
  }
  .sign-document-description {
    color: $gray-color-dark;
    font-size: $font-size-sm;
  }
}
</style>
